var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoadingSpinner',{attrs:{"loading":_vm.isLoading,"text":_vm.$lang.sending_data}}),_c('AzmoonExecuteForm',{attrs:{"isLoading":_vm.isLoading,"permissions":['admin'],"mode":"add"},on:{"submit":_vm.save,"handleBack":_vm.handleBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }